export const DEMO_BANNER = 'Demo mode: gift cards are simulated. No real card is issued until LocalCard is connected.';
/** First source carrying a usable `rewards` object wins (partnerGetMe before the page-load profile). */
export function readRewards(...sources) {
    for (const s of sources) {
        if (!s || typeof s !== 'object')
            continue;
        const r = s.rewards;
        if (r === undefined)
            continue;
        if (!r || typeof r !== 'object')
            return null;
        const cfg = r;
        if (cfg.enabled === false)
            return null;
        const catalogue = Array.isArray(cfg.catalogue)
            ? cfg.catalogue.filter((c) => !!c && typeof c.key === 'string' && typeof c.label === 'string')
            : [];
        return { mode: typeof cfg.mode === 'string' ? cfg.mode : 'demo', catalogue };
    }
    return null;
}
export function isDemo(config, cards = []) {
    return config?.mode === 'demo' || cards.some((c) => c.mode === 'demo');
}
export function catalogueLabel(config, key) {
    return config?.catalogue.find((c) => c.key === key)?.label ?? key;
}
/** The card's own label (the server resolves it), else the catalogue's, else the key. */
export function cardLabel(config, card) {
    return card.catalogueLabel || catalogueLabel(config, card.catalogueKey);
}
/** Requested, but LocalCard refused it for lack of float; it issues once the float is topped up. */
export function isHeld(card) {
    return card.status === 'requested' && card.holdReason === 'awaiting_float';
}
export function cardMember(card) {
    return card.memberName || 'Broker';
}
export const GIFT_CARD_STATUS = {
    requested: { label: 'Requested', tone: 'amber' },
    issuing: { label: 'Issuing', tone: 'amber' },
    issued: { label: 'Issued', tone: 'green' },
    cancelled: { label: 'Cancelled', tone: 'neutral' },
};
